module.exports = __webpack_public_path__ + "static/faq_img1@2x-e8653a69801ac0446a8eef7874d142a1.png";